/* eslint-disable */
// Auto-generated by src/sripts/generate-images.js

import gin_bg_avif_480_1 from "./home/gin-bg-480.avif";
import gin_bg_avif_768_2 from "./home/gin-bg-768.avif";
import gin_bg_avif_1200_3 from "./home/gin-bg-1200.avif";
import gin_bg_avif_1920_4 from "./home/gin-bg-1920.avif";
import gin_bg_webp_480_5 from "./home/gin-bg-480.webp";
import gin_bg_webp_768_6 from "./home/gin-bg-768.webp";
import gin_bg_webp_1200_7 from "./home/gin-bg-1200.webp";
import gin_bg_webp_1920_8 from "./home/gin-bg-1920.webp";
import gin_bg_jpg_480_9 from "./home/gin-bg-480.jpg";
import gin_bg_jpg_768_10 from "./home/gin-bg-768.jpg";
import gin_bg_jpg_1200_11 from "./home/gin-bg-1200.jpg";
import gin_bg_jpg_1920_12 from "./home/gin-bg-1920.jpg";
import liqourNewest_avif_480_13 from "./home/liqourNewest-480.avif";
import liqourNewest_avif_768_14 from "./home/liqourNewest-768.avif";
import liqourNewest_avif_1200_15 from "./home/liqourNewest-1200.avif";
import liqourNewest_avif_1920_16 from "./home/liqourNewest-1920.avif";
import liqourNewest_webp_480_17 from "./home/liqourNewest-480.webp";
import liqourNewest_webp_768_18 from "./home/liqourNewest-768.webp";
import liqourNewest_webp_1200_19 from "./home/liqourNewest-1200.webp";
import liqourNewest_webp_1920_20 from "./home/liqourNewest-1920.webp";
import liqourNewest_jpg_480_21 from "./home/liqourNewest-480.jpg";
import liqourNewest_jpg_768_22 from "./home/liqourNewest-768.jpg";
import liqourNewest_jpg_1200_23 from "./home/liqourNewest-1200.jpg";
import liqourNewest_jpg_1920_24 from "./home/liqourNewest-1920.jpg";
import restraunt_avif_480_25 from "./home/restraunt-480.avif";
import restraunt_avif_768_26 from "./home/restraunt-768.avif";
import restraunt_avif_1200_27 from "./home/restraunt-1200.avif";
import restraunt_avif_1920_28 from "./home/restraunt-1920.avif";
import restraunt_webp_480_29 from "./home/restraunt-480.webp";
import restraunt_webp_768_30 from "./home/restraunt-768.webp";
import restraunt_webp_1200_31 from "./home/restraunt-1200.webp";
import restraunt_webp_1920_32 from "./home/restraunt-1920.webp";
import restraunt_jpg_480_33 from "./home/restraunt-480.jpg";
import restraunt_jpg_768_34 from "./home/restraunt-768.jpg";
import restraunt_jpg_1200_35 from "./home/restraunt-1200.jpg";
import restraunt_jpg_1920_36 from "./home/restraunt-1920.jpg";
import bottega_avif_480_37 from "./home/bottega-480.avif";
import bottega_avif_768_38 from "./home/bottega-768.avif";
import bottega_avif_1200_39 from "./home/bottega-1200.avif";
import bottega_avif_1920_40 from "./home/bottega-1920.avif";
import bottega_webp_480_41 from "./home/bottega-480.webp";
import bottega_webp_768_42 from "./home/bottega-768.webp";
import bottega_webp_1200_43 from "./home/bottega-1200.webp";
import bottega_webp_1920_44 from "./home/bottega-1920.webp";
import bottega_jpg_480_45 from "./home/bottega-480.jpg";
import bottega_jpg_768_46 from "./home/bottega-768.jpg";
import bottega_jpg_1200_47 from "./home/bottega-1200.jpg";
import bottega_jpg_1920_48 from "./home/bottega-1920.jpg";
import satiata_avif_480_49 from "./home/satiata-480.avif";
import satiata_avif_768_50 from "./home/satiata-768.avif";
import satiata_avif_1200_51 from "./home/satiata-1200.avif";
import satiata_avif_1920_52 from "./home/satiata-1920.avif";
import satiata_webp_480_53 from "./home/satiata-480.webp";
import satiata_webp_768_54 from "./home/satiata-768.webp";
import satiata_webp_1200_55 from "./home/satiata-1200.webp";
import satiata_webp_1920_56 from "./home/satiata-1920.webp";
import satiata_jpg_480_57 from "./home/satiata-480.jpg";
import satiata_jpg_768_58 from "./home/satiata-768.jpg";
import satiata_jpg_1200_59 from "./home/satiata-1200.jpg";
import satiata_jpg_1920_60 from "./home/satiata-1920.jpg";

const images = {
  "gin-bg": {
    "avif": {
      "480": gin_bg_avif_480_1,
      "768": gin_bg_avif_768_2,
      "1200": gin_bg_avif_1200_3,
      "1920": gin_bg_avif_1920_4,
    },
    "webp": {
      "480": gin_bg_webp_480_5,
      "768": gin_bg_webp_768_6,
      "1200": gin_bg_webp_1200_7,
      "1920": gin_bg_webp_1920_8,
    },
    "jpg": {
      "480": gin_bg_jpg_480_9,
      "768": gin_bg_jpg_768_10,
      "1200": gin_bg_jpg_1200_11,
      "1920": gin_bg_jpg_1920_12,
    },
  },
  "liqourNewest": {
    "avif": {
      "480": liqourNewest_avif_480_13,
      "768": liqourNewest_avif_768_14,
      "1200": liqourNewest_avif_1200_15,
      "1920": liqourNewest_avif_1920_16,
    },
    "webp": {
      "480": liqourNewest_webp_480_17,
      "768": liqourNewest_webp_768_18,
      "1200": liqourNewest_webp_1200_19,
      "1920": liqourNewest_webp_1920_20,
    },
    "jpg": {
      "480": liqourNewest_jpg_480_21,
      "768": liqourNewest_jpg_768_22,
      "1200": liqourNewest_jpg_1200_23,
      "1920": liqourNewest_jpg_1920_24,
    },
  },
  "restraunt": {
    "avif": {
      "480": restraunt_avif_480_25,
      "768": restraunt_avif_768_26,
      "1200": restraunt_avif_1200_27,
      "1920": restraunt_avif_1920_28,
    },
    "webp": {
      "480": restraunt_webp_480_29,
      "768": restraunt_webp_768_30,
      "1200": restraunt_webp_1200_31,
      "1920": restraunt_webp_1920_32,
    },
    "jpg": {
      "480": restraunt_jpg_480_33,
      "768": restraunt_jpg_768_34,
      "1200": restraunt_jpg_1200_35,
      "1920": restraunt_jpg_1920_36,
    },
  },
  "bottega": {
    "avif": {
      "480": bottega_avif_480_37,
      "768": bottega_avif_768_38,
      "1200": bottega_avif_1200_39,
      "1920": bottega_avif_1920_40,
    },
    "webp": {
      "480": bottega_webp_480_41,
      "768": bottega_webp_768_42,
      "1200": bottega_webp_1200_43,
      "1920": bottega_webp_1920_44,
    },
    "jpg": {
      "480": bottega_jpg_480_45,
      "768": bottega_jpg_768_46,
      "1200": bottega_jpg_1200_47,
      "1920": bottega_jpg_1920_48,
    },
  },
  "satiata": {
    "avif": {
      "480": satiata_avif_480_49,
      "768": satiata_avif_768_50,
      "1200": satiata_avif_1200_51,
      "1920": satiata_avif_1920_52,
    },
    "webp": {
      "480": satiata_webp_480_53,
      "768": satiata_webp_768_54,
      "1200": satiata_webp_1200_55,
      "1920": satiata_webp_1920_56,
    },
    "jpg": {
      "480": satiata_jpg_480_57,
      "768": satiata_jpg_768_58,
      "1200": satiata_jpg_1200_59,
      "1920": satiata_jpg_1920_60,
    },
  },
};

export default images;
